/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { TourFilter } from '@construction-sites/models/tour-filter';
import * as ConstructionSiteActions from '@construction-sites/store/construction-sites.actions';
import { ConstructionSitesState, initialState } from '@construction-sites/store/construction-sites.state';

export function constructionSitesReducer(
  state = initialState,
  action: ConstructionSiteActions.ConstructionSiteActions
): ConstructionSitesState {
  switch (action.type) {
    case ConstructionSiteActions.LOAD_CONSTRUCTION_SITES:
    case ConstructionSiteActions.LOAD_TOURS:
      return {
        ...state,
        isActionPending: true
      };
    case ConstructionSiteActions.LOAD_CONSTRUCTION_SITES_FAILURE:
    case ConstructionSiteActions.LOAD_TOURS_FAILURE:
      return {
        ...state,
        isActionPending: false
      };
    case ConstructionSiteActions.LOAD_CONSTRUCTION_SITES_SUCCESS:
      return {
        ...state,
        constructionSites: action.constructionSites,
        isActionPending: false
      };
    case ConstructionSiteActions.SET_TOUR_FILTER:
      return {
        ...state,
        tourFilter: Object.assign(state.tourFilter || { }, action.tourFilter as TourFilter)
      };
    case ConstructionSiteActions.LOAD_TOURS_SUCCESS:
      return {
        ...state,
        tours: action.tours,
        isActionPending: false
      };
    case ConstructionSiteActions.SET_CURRENT_CONSTRUCTION_SITE:
      return {
        ...state,
        currentConstructionSite: action.constructionSite
      };
    default:
      return state;
  }
}
